import * as Sentry from '@sentry/react';
import type { FeatureFlagsIntegration } from '@sentry/react';

/**
 * The flags a page was rendered under, on every subsequent Sentry event.
 *
 * No `Sentry.setUser` here, unlike the recruiter-facing frontends. The
 * directory is unauthenticated and holds no id for the person reading it, and
 * this is not the place to start minting one. The `tenant` tag set at init is
 * the only attribution an issue gets.
 *
 * This module imports the Sentry SDK and nothing else.
 */
// Generic in the flag object rather than `Record<string, boolean>`: the caller
// passes an interface, and an interface has no implicit index signature.
export function setSentryFeatureFlags<T extends object>(
  flags: T | undefined,
): void {
  if (!flags) {
    return;
  }

  const integration =
    Sentry.getClient()?.getIntegrationByName<FeatureFlagsIntegration>(
      'FeatureFlags',
    );

  if (!integration) {
    return;
  }

  Object.entries(flags).forEach(([name, value]) => {
    integration.addFeatureFlag(name, value);
  });
}
